import { Transaction } from "../../../types/transaction";
import {
    TransactionDto,
    TransactionDtoInput,
} from "../../transactions/transaction.dto";

export interface MultipleMatchingConflict {
    transactionFromDestination: Transaction;
    transactionsToMerge: Transaction[];
}

export class MultipleMatchingConflictDto {
    transactionFromDestination: TransactionDto;
    transactionsToMerge: TransactionDto[];

    constructor(conflict: MultipleMatchingConflict) {
        this.transactionFromDestination = new TransactionDto(
            conflict.transactionFromDestination as TransactionDtoInput,
        );
        this.transactionsToMerge = conflict.transactionsToMerge.map(
            (t) => new TransactionDto(t as TransactionDtoInput),
        );
    }

    static deserialize(
        dto: MultipleMatchingConflictDto,
    ): MultipleMatchingConflict {
        return {
            transactionFromDestination: TransactionDto.deserialize(
                dto.transactionFromDestination,
            ) as Transaction,
            transactionsToMerge: dto.transactionsToMerge.map(
                (t) => TransactionDto.deserialize(t) as Transaction,
            ),
        };
    }
}
